"use client";

import { cn } from "@workspace/ui/lib/utils";
import { memo } from "react";
import { getGenreDisplayName } from "@workspace/shared-utils";

export interface GenreBadgeProps {
	genre: string;
	className?: string;
}

/**
 * A standardized component for displaying individual genre badges.
 * Uses the muted style from SetCard for consistency across the platform.
 * Applies genre formatting automatically.
 */
export const GenreBadge = memo<GenreBadgeProps>(function GenreBadge({
	genre,
	className,
}) {
	return (
		<div
			className={cn(
				"rounded-md border bg-muted px-1.5 py-0.5 text-muted-foreground text-xs",
				className,
			)}
		>
			{getGenreDisplayName(genre)}
		</div>
	);
});
